// Common timezone options
export const TIMEZONE_OPTIONS = [
  { value: 'UTC', label: 'UTC', group: 'UTC' },
  { value: 'America/New_York', label: 'New York - Eastern Time (ET)', group: 'Americas' },
  { value: 'America/Chicago', label: 'Chicago - Central Time (CT)', group: 'Americas' },
  { value: 'America/Denver', label: 'Denver - Mountain Time (MT)', group: 'Americas' },
  { value: 'America/Los_Angeles', label: 'Los Angeles - Pacific Time (PT)', group: 'Americas' },
  { value: 'America/Sao_Paulo', label: 'São Paulo - Brasília Time (BRT)', group: 'Americas' },
  { value: 'Europe/London', label: 'London - Greenwich Mean Time (GMT)', group: 'Europe' },
  { value: 'Europe/Berlin', label: 'Berlin - Central European Time (CET)', group: 'Europe' },
  { value: 'Europe/Paris', label: 'Paris - Central European Time (CET)', group: 'Europe' },
  { value: 'Europe/Rome', label: 'Rome - Central European Time (CET)', group: 'Europe' },
  { value: 'Europe/Madrid', label: 'Madrid - Central European Time (CET)', group: 'Europe' },
  { value: 'Europe/Amsterdam', label: 'Amsterdam - Central European Time (CET)', group: 'Europe' },
  { value: 'Europe/Zurich', label: 'Zurich - Central European Time (CET)', group: 'Europe' },
  { value: 'Asia/Tokyo', label: 'Tokyo - Japan Standard Time (JST)', group: 'Asia' },
  { value: 'Asia/Shanghai', label: 'Shanghai - China Standard Time (CST)', group: 'Asia' },
  { value: 'Asia/Hong_Kong', label: 'Hong Kong - Hong Kong Time (HKT)', group: 'Asia' },
  { value: 'Asia/Singapore', label: 'Singapore - Singapore Time (SGT)', group: 'Asia' },
  { value: 'Asia/Kolkata', label: 'Mumbai - India Standard Time (IST)', group: 'Asia' },
  { value: 'Asia/Dubai', label: 'Dubai - Gulf Standard Time (GST)', group: 'Asia' },
  { value: 'Australia/Sydney', label: 'Sydney - Australian Eastern Time (AET)', group: 'Pacific' },
  {
    value: 'Australia/Melbourne',
    label: 'Melbourne - Australian Eastern Time (AET)',
    group: 'Pacific',
  },
  { value: 'Pacific/Auckland', label: 'Auckland - New Zealand Time (NZST)', group: 'Pacific' },
];
